import {useMemo} from 'react';
import {useJobContext} from 'contexts/JobContext';
import {useAppContext} from 'contexts/ApplicationContext';
import {PartialJob} from 'shared/types/PartialJob';

export const useJobPDFVerificationLink = () => {
    const {userProfile} = useAppContext();
    const {job} = useJobContext() as PartialJob;

    const pdfLink = useMemo(() => {
        const pdfLinkWithName = {
            url: `/v2/pdf/preview/${job?.id}`,
            link: `<a href="/v2/pdf/preview/${job?.id}" target="_blank">Job Properties PDF</a>`,
            name: 'job properties PDF',
        };
        if (
            userProfile?.hasOwnProperty('showJobPropertiesTablePdf') &&
            userProfile?.showJobPropertiesTablePdf &&
            userProfile?.defaultJobPropertiesPdf == 2
        ) {
            pdfLinkWithName.url = `/v2/pdf/preview/${job?.id}`;
            pdfLinkWithName.link = `<a href="/v2/pdf/preview/${job?.id}" target="_blank">Job Details PDF</a>`;
            pdfLinkWithName.name = 'job details PDF';
        } else if (
            userProfile?.hasOwnProperty('showOrderAcknowledgementPdf') &&
            userProfile?.showOrderAcknowledgementPdf &&
            userProfile?.defaultJobPropertiesPdf == 3
        ) {
            pdfLinkWithName.url = `/quotePdf.php?jobId=${job?.id}`;
            pdfLinkWithName.link = `<a href="/quotePdf.php?jobId=${job?.id}" target="_blank">Quote PDF</a>`;
            pdfLinkWithName.name = 'quote PDF';
        }
        return pdfLinkWithName;
    }, [userProfile, job]);

    return {
        pdfLink,
    };
};
